import { type FC, type Key } from "react";

import { cx } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing, type TreeSelectNode } from "@snapchat/snap-design-system";

import { PageHeader } from "../../layout/components";
import { dropdownButtonContainer } from "../../lens-insights/components/shared";
import { Flexbox } from "../../shared/components";

import { TargetingSpecFilter } from "./TargetingSpecFilter";
import { Subtitle, Title } from "./messages.generated";
import { HeaderSectionContainer, subtitle, titleStyle } from "./shared";

const PageTitle = styled(PageHeader)`
    flex-grow: 1;
    width: 300px;
    margin-right: ${Spacing.MD}px;
`;

interface CommunityAudienceHeaderProps {
    filterTree: TreeSelectNode[];
    onFilterCheck: (checkedKeys: Key[], triggeringKey: Key) => void;
    onResetFilters: () => void;
}

export const CommunityAudienceHeader: FC<CommunityAudienceHeaderProps> = ({
    filterTree,
    onFilterCheck,
    onResetFilters,
}) => {
    return (
        <HeaderSectionContainer className={cx(dropdownButtonContainer)}>
            <Flexbox className={titleStyle} flexDirection={"row"}>
                <PageTitle>
                    <Title />
                </PageTitle>
                <TargetingSpecFilter treeData={filterTree} onCheck={onFilterCheck} resetFilter={onResetFilters} />
            </Flexbox>
            <Flexbox className={subtitle}>
                <Subtitle />
            </Flexbox>
        </HeaderSectionContainer>
    );
};
